var map = {
	"./icon-calendar-payment.svg": 481,
	"./icon-impact-report.svg": 482,
	"./icon-maintenance.svg": 230,
	"./icon-quarterly-report.svg": 483,
	"./icon-tax-document.svg": 484
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2218;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/icon\-.*\.svg$
// module id = 2218
// module chunks = 1